module.exports = __webpack_public_path__ + "static/media/pie_insurance.d236431b.jpg";